import { FC } from 'react'
import { Box, Paper, Typography } from '@mui/material'
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useUiActionsByResource } from 'hooks'
import { Skeleton } from '@mui/material';
import { useHistory } from 'react-router'
import { getFullPathFromUrl, useQuery } from 'packages/core'
import appConfig from 'config'
import { useTranslation } from 'react-i18next'

const smallScreenWidth = 960
const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            position: 'relative',
            padding: theme.spacing(2),
            display: 'flex',
            justifyContent: 'space-between',
            background: '#fbfbfd',
            boxShadow: 'none !important',

            [`@media (max-width:${smallScreenWidth - 1}px)`]: {
                flexDirection: 'column',
            },
        },
        paddingdiv: {
            padding: '0 20px',
            width: '100%',
            display: 'flex',
            flexWrap: 'wrap',
        },
        innerdiv: {
            marginRight: '25px',
            width: '160px',
            padding: '4px 8px',
            fontSize: '11px',
            color: theme?.palette?.primary?.main,
            boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.05) !important',
            textTransform: 'capitalize',
            marginBottom: '20px',
            border: `1px solid ${theme?.palette?.common?.white}`,
            '&:hover': {
                cursor: 'pointer',
            },
        },
    }),
)

export const ApplicationActions: FC<any> = ({ data }) => {
    const classes = useStyles()
    const { t } = useTranslation()
    const NOUN = 'ITShopMS'
    const VERB = data.isAzureApplication ? 'AzureApps' : 'Apps'

    const { data: applicationActions, isLoading } = useUiActionsByResource(
        data.id,
        NOUN,
        VERB,
    )
    const query = useQuery()
    const history = useHistory()

    const handleActionClick = (item: any) => {
        query.delete('selected')
        query.set('workflowName', item.requestWorkflowName)
        query.set('resourceID', data.resourceID)
        query.set('returnUrl', getFullPathFromUrl())
        history.push(
            `${
                appConfig.APP_SUBPATH
            }/applications/workflows?${query.toString()}`,
        )
    }
    return (
        <Paper className={classes.root}>
            {isLoading ? (
                <Box
                    style={{ display: 'block', width: '100%' }}
                    paddingRight={4}
                >
                    <Skeleton height={40} />
                </Box>
            ) : (
                <Box className={classes.paddingdiv}>
                    {applicationActions && applicationActions.length > 0 ? (
                        applicationActions.map((item: any, index: number) => (
                            <Paper
                                key={`action-item-${index}`}
                                className={classes.innerdiv}
                                onClick={() => handleActionClick(item)}
                            >
                                {item.friendlyName}
                            </Paper>
                        ))
                    ) : (
                        <Typography>{t('NoActionFound')}</Typography>
                    )}
                </Box>
            )}
        </Paper>
    )
}
